const {Component} = require("react");
const PropTypes = require("prop-types");
const managerApi = require("app/pipelines/checkout/manager");
const $ = require("app/util/element");
const debounce = require("app/util/debounce");
const element = require("app/util/element");
const hammer = require("app/util/hammer");
const screen = require("app/util/screen");
const {isFocusableElement} = require("app/util/focus");
const {getBodyScrollingElement} = require("app/util/animateScroll");
const Browser = require("app/services/browser");
const env = require("app/services/env");
const googleAnalytics = require('app/services/googleAnalytics');
const AlcoholWarning = require("app/components/checkout/AlcoholWarning");
const axios = require("axios");
const router = require("app/services/router");
const Trans = require('app/components/trans/Trans')

class Cart extends Component {

	static get propTypes() {
		return {
			open: PropTypes.bool
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			step: props.open ? 0 : null,
			loadedStep: 0,
			skipWarning: false
		};
	}

	setWarning(input){
		this.setState({skipWarning: input});
	}

	componentDidMount() {
		this.pipelines.change.pipe(payload => {
			this.forceUpdate();
			return payload;
		});

		/*this.pipelines.add.response.pipe(payload => {
			if (!this.isOpen()) {
				managerApi.open.dispatch({cart: "product"});
			}

			return payload;
		});*/

		const handleClickAway = e => {
			if (!this.isOpen() || Browser.ie()) {
				return;
			}

			let targetElement = element(e.target);

			// Skip if pikaday instance
			if (targetElement.is(".pika-single") || targetElement.parent(".pika-single") || targetElement.parent(".modal-container")) {
				return;
			}

			if (!this.bodyElement.contains(e.target)) {
				return this.exit();
			}

			if (!this.activeStepElement.contains(e.target)) {
				return this.prev();
			}
		};

		// Bind on click to body (for click outside)
		document.addEventListener("focus", e => {
			if (isFocusableElement(e.target)) {
				handleClickAway(e);
			}

		}, true);

		// Must add the wrapper on tap to prevent some issues with "tapping" pikaday
		const bodyWrapper = document.body.querySelector(".body-wrapper");
		const checkoutWrapper = document.body.querySelector(".checkout-wrapper");

		if (bodyWrapper) {
			bodyWrapper.addEventListener("click", e => {
				if (screen.desktop()) {
					handleClickAway(e);
				}
			});

			hammer(bodyWrapper).on("tap", e => {
				if (screen.mobile()) {
					handleClickAway(e);
				}
			});
		}

		if (checkoutWrapper) {
			checkoutWrapper.addEventListener("click", e => {
				if (screen.desktop()) {
					handleClickAway(e);
				}
			});

			hammer(checkoutWrapper).on("tap", e => {
				if (screen.mobile()) {
					handleClickAway(e);
				}
			});
		}

		window.addEventListener("resize", this.readjustPositioning);
		window.addEventListener("orientationchange", this.readjustPositioning);
		//window.addEventListener("scroll", this.readjustPositioning);
		//document.body.addEventListener("scroll", this.readjustPositioning);
	}

	readjustPositioningNow = () => {
		if (this.isOpen()) {
			this.setStep(this.state.step);
			this.forceUpdate();
		}
	};

	readjustPositioning = debounce(100, () => {
		this.readjustPositioningNow();
	});

	componentWillReceiveProps(nextProps) {
		if (nextProps.hasOwnProperty("open") && (nextProps.open !== this.isOpen())) {
			nextProps.open ?
				this.open() :
				this.close();
		}
	}

	get baseClassName() {
		return "checkout";
	}

	get className() {
		let classList = [this.baseClassName];

		if (this.isOpen()) {
			classList.push("active");
		}

		return classList.join(" ");
	}

	get steps() {
		return [];
	}

	get startIndex() {
		return 0;
	}

	get cart() {
		// ...
	}

	get pipelines() {
		// ...
	}

	get style() {
		let style = {};

		// Pull width
		let pushWidth = -this.getPullWidth(this.state.step);

		style.transform = this.isOpen() ?
			`translate3d(${pushWidth}px, 0, 0)` :
			`translate3d(0, 0, 0)`;

		// Set top based on body-wrapper scroll top
		/*const bodyWrapper = document.querySelector(".body-wrapper");

		if (bodyWrapper) {
			style.top = bodyWrapper.scrollTop;
		}*/

		return style;
	}

	get activeStepElement() {
		return this.bodyElement.querySelector(".step.active");
	}

	get isWideStep() {
		if(this.state.step === 3) {
			return true;
		}

		return false;
	}

	getPullWidth(step) {
		let pullWidth = 0;

		if (step !== null) {
			const steps = this.bodyElement.children;
			let stepElement;

			for (let i = 0; i <= step; i++) {
				stepElement = $(steps[i]);
				stepElement.addClass("fake-show");

				pullWidth += stepElement.width;

				stepElement.removeClass("fake-show");
			}
		}

		return pullWidth;
	}

	setStep(index) {
		const bodyWrapper = document.querySelector(".body-wrapper");
		const bodyScrollTop = getBodyScrollingElement().scrollTop;
		const bodyWrapperScrollTop = bodyWrapper ? bodyWrapper.scrollTop : 0;

		if(index && this.steps[index].component.prototype.gaInfo && !env.debug()){
			googleAnalytics('config', 'UA-5570334-3', this.steps[index].component.prototype.gaInfo);
		}

		//console.log(getBodyScrollingElement(), bodyScrollTop, bodyWrapperScrollTop);

		// Set body class
		let classList = document.body.className.split(" ");
		let classNameIndex = classList.indexOf("has-open-cart");

		if ((index !== null) && (classNameIndex === -1)) {
			classList.push("has-open-cart");
		}
		else if ((index === null) && (classNameIndex !== -1)) {
			classList.splice(classNameIndex, 1);
		}

		document.body.className = classList.join(" ");

		// Pull elements
		const header = document.body.querySelector(":scope > .body-wrapper .header");
		const content = document.body.querySelector(":scope > .body-wrapper .content");
		const footer = document.body.querySelector(":scope > .body-wrapper .footer");
		const width = -this.getPullWidth(index);

		// Adjust body wrapper scroll on open
		if (bodyWrapper && index != null && !this.isOpen()) {
			bodyWrapper.scrollTop = bodyScrollTop;
			header.style.top = `${bodyScrollTop}px`;
			getBodyScrollingElement().scrollTop = 0;
		}

		// Restore body scroll when closing
		if (bodyWrapper && index == null && this.isOpen()) {
			getBodyScrollingElement().scrollTop = bodyWrapperScrollTop;
			bodyWrapper.scrollTop = 0;
			header.style.top = "";
		}

		if (window.innerWidth > 650) {
			[header, content, footer].forEach(el => {
				el.style.transform = width === 0 ? "" : `translate3d(${width}px, 0, 0)`;
			});
		} else {
			[header, content, footer].forEach(el => {
				el.style.transform = width === 0 ? "" : `translate3d(0, 0, 0)`;
			});
		}

		if (index > 0) {
			axios.post(router.route("api.tracking.checkout-step-viewed"), {step: index, cart_id: this.cart.guid});
		}

		this.setState({
			step: index,
			loadedStep: Math.max(this.state.loadedStep, index)
		});
	}

	prev() {

		// Check if at the first step
		if (this.state.step === 0) {
			return this.exit();
		}

		this.setStep((this.state.step === null) || (this.state.step === 0) ? null : this.state.step - 1);

	}

	next() {
		// Check if at the end of the flow
		if (this.state.step === this.steps.length - 1) {
			return;
		}

		this.setStep(typeof this.state.step === "number" ? this.state.step + 1 : 0);

	}

	close() {
		if (!this.isOpen()) {
			return;
		}

		this.setStep(null);
	}

	open() {
		if (this.isOpen()) {
			return;
		}

		this.setStep(0);
		googleAnalytics('config', 'UA-5570334-3', {
			'page_title': translate('Ser kurven'),
			'page_path': translate('/ser-kurven/')
		});

		axios.post(router.route("api.tracking.view-cart"), {cart_id: this.cart.guid});
	}

	isOpen() {
		return this.state.step !== null;
	}

	forceStep = (step) => {
		this.setStep(step);
	};

	exit = () => {
		managerApi.close.dispatch();
	};

	renderSteps() {

		return this.steps
			.map((step, i) => {
				const Step = step.component;
				const props = step.props || {};
				const index = i + 1 - this.startIndex;
				const count = this.steps.length - this.startIndex;
				const hasPrevStep = i > 0;
				const hasNextStep = i < this.steps.length - 1;

				return (<Step key={i}
											index={index}
											count={count}
											active={i === this.state.step}
											blur={i < this.state.step}
											next={this.next.bind(this)}
											prev={this.prev.bind(this)}
											close={this.exit}
											hasPrevStep={hasPrevStep}
											hasNextStep={hasNextStep}
											forceStep={this.forceStep}
											cart={this.cart}
											pipelines={this.pipelines}
											{...props}/>);
			});
	}

	renderAlcoholWarning() {
		if (!this.isOpen()) {
			return null;
		}

		return <AlcoholWarning floating={true} isWideStep={this.isWideStep}/>;
	}

	render() {
		return (
			<React.Fragment>
				<div ref={el => this.bodyElement = el} className={this.className} style={this.style}>
					{this.cart ? this.renderSteps() : null}
				</div>
				{this.renderAlcoholWarning()}
			</React.Fragment>

		);
	}

}

module.exports = Cart;
